import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

//Actions
import {resetStaticData, resetSearchRoomData} from '@stencil/hotels-cg-reducer/src/details/actions';
import {resetUgcReviewV2} from '@stencil/hotels-cg-reducer/src/ugc/actions';

const useResetDetailsData = () => {
  const dispatch = useDispatch();

  const resetDetailsCaller = useCallback(() => {
    dispatch(resetStaticData());
    dispatch(resetSearchRoomData());
    dispatch(resetUgcReviewV2());
  }, []);

  return {resetDetailsCaller};
};

export default useResetDetailsData;
